import queryString from 'query-string';

import config from '@nerdwallet/app-config';

import Paths from '@lib/paths';

import { isRelativeUri, isAllowedNerdWalletDomain } from './redirect';

const getRedirectUri = (uri) => {
  if (isAllowedNerdWalletDomain(uri)) {
    return uri;
  }
  if (isRelativeUri(uri)) {
    return `${config.SITE_BASE_URL}${uri}`;
  }
  return `${config.SITE_BASE_URL}/home`;
};

/*
 This function takes in a location parameter and returns an object of parameters to pass to
 nw-auth-links LinkGenerator.
 It preserves non-segment Query parameters and appends them to the auth0 RedirectTo parameter.
 */
export const getAuth0Params = (location) => {
  /*
    This method needed to be adapted to handle ServerSide requests
    For server side: queryString.parseUrl(location?.url).query 
    For client side (default): queryString.parseUrl(location?.url).query;
  */
  let queryParams: queryString.ParsedQuery | queryString.ParsedUrl = {};

  if (location.search) {
    queryParams = queryString.parse(location?.search);
  } else if (location.url) {
    queryParams = queryString.parseUrl(location?.url).query;
  }

  const stringifiedQueryParams = Object.entries(queryParams).reduce(
    (acc, [key, value]) => {
      if (typeof value === 'string') {
        acc[key] = value;
      } else if (Array.isArray(value)) {
        // If there are duplicate query-params, use the first.
        [acc[key]] = value;
      } else {
        acc[key] = undefined;
      }
      return acc;
    },
    {} as { [key: string]: string | undefined },
  );
  const {
    redirectTo,
    driverPageName,
    driverLocation,
    driverSubLocation,
    driverElement,
    deployableName,
    deployableVersion,
    driverPageUrl,
    driverPageViewId,
    driverContentId,
    driverContentSource,
    driverFlowName,
    anonymousUserId,
    mostRecentTraditionalDeviceId,
    // Legacy redirect qp
    redirect_uri: redirectUri,
    ...remainingParams
  } = stringifiedQueryParams;

  // Append remaining query params to the redirect value
  let redirect = redirectTo;
  if (!redirect) {
    if (remainingParams.flow) {
      redirect = `${config.SITE_BASE_URL}${Paths.ONBOARDING}${
        redirectUri ? `?redirect_uri=${redirectUri}` : ''
      }`;
    } else if (redirectUri) {
      redirect = getRedirectUri(redirectUri);
    } else {
      redirect = `${config.SITE_BASE_URL}${Paths.DASHBOARD_HOME}`;
    }
  }

  const remainingQueryParams = queryString.stringify(remainingParams);
  if (remainingQueryParams) {
    redirect += redirect.includes('?') ? '&' : '?';
    redirect += remainingQueryParams;
  }

  return {
    redirectTo: redirect,
    driverPageName,
    driverLocation,
    driverSubLocation,
    driverElement,
    deployableName,
    deployableVersion,
    driverPageUrl,
    driverPageViewId,
    driverContentId,
    driverContentSource,
    driverFlowName,
    anonymousUserId,
    mostRecentTraditionalDeviceId,
  };
};
